// constants imported from mobile folder

import { useParams } from "react-router";
import {getVenueRoles} from "../modules/App/AppReducer";

export const DISPLAY_FORMAT = 'L';
export const ISO_FORMAT = 'YYYY-MM-DD';
export const ISO_MONTH_FORMAT = 'YYYY-MM';

export const imageKitUrl = 'https://ik.imagekit.io/venuemonk'

export const AWS_SOURCE_IMAGE_URL = `https://cdn.venuemonk.com`;
export const AWS_RAW_SOURCE_IMAGE_URL = 'https://venuemonk-images.s3.ap-south-1.amazonaws.com';
export const GUMLET_URL_BASE_URL = `https://vmnk.gumlet.io`
export const IMAGEKIT_BUCKET_NAME = 'venuemonk';
export const IMAGEKIT_SOURCE_IMAGE_URL = `https://ik.imagekit.io/${IMAGEKIT_BUCKET_NAME}`;

export const DEFAULT_SOURCE_IMAGE_URL= `https://vmnk.gumlet.io`
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';

export const HORIZONTAL_ORIENTATION = 'horizontal';
export const VERTICAL_ORIENTATION = 'vertical';
export const VERTICAL_SCROLLABLE = 'verticalScrollable';

export const ICON_BEFORE_POSITION = 'before';
export const ICON_AFTER_POSITION = 'after';

export const INFO_POSITION_TOP = 'top';
export const INFO_POSITION_BOTTOM = 'bottom';
export const INFO_POSITION_BEFORE = 'before';
export const INFO_POSITION_AFTER = 'after';

export const ANCHOR_LEFT = 'left';
export const ANCHOR_RIGHT = 'right';

export const OPEN_DOWN = 'down';
export const OPEN_UP = 'up';

export const DAY_SIZE = 39;
export const BLOCKED_MODIFIER = 'blocked';
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export const FANG_WIDTH_PX = 20;
export const FANG_HEIGHT_PX = 10;
export const DEFAULT_VERTICAL_SPACING = 22;

export const MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);

export const VENDOR_MODEL = "vendors"

export const roleOptions = [
    {
        value: 'member',
        label: 'Member'
    },
    {
        value: 'admin',
        label: 'Admin'
    },
    {
        value: 'owner',
        label: 'Owner'
    }
]


export const callingStatusList = [
    {
        value: "Not Yet Call",
        label: "Not Yet Call"
    },
    {
        value: "Call Later",
        label: "Call Later"
    },
    {
        value: "Language Problem",
        label: "Language Problem"
    },
    {
        value: "Busy",
        label: "Busy"
    },
    {
        value: "Failed",
        label: "Failed"
    },
    {
        value: "Disconnected",
        label: "Disconnected"
    },
    {
        value: "Not Connected",
        label: "Not Connected"
    },
    {
        value: "Abandoned",
        label: "Abandoned"
    },
    {
        value: "Switch Off",
        label: "Switch Off"
    },
    {
        value: "Not Picking",
        label: "Not Picking"
    },
    {
        value: "Answered",
        label: "Answered"
    },
    {
        value: "Follow Up",
        label: "Follow Up"
    },
    {
        value: "Hang Up",
        label: "Hang Up"
    }
]


export const leadSource = [
    {
        value: 'WhatsApp',
        label: 'WhatsApp'
    },
    {
        value: 'Instagram',
        label: 'Instagram'
    },
    {
        value: 'Facebook',
        label: 'Facebook'
    },
    {
        value: 'Website',
        label: 'Website'
    },
    {
        value: 'Others',
        label: 'Others'
    },
]

export const OperationalCity = [
    {
        value: 'gurgaon',
        label: 'Gurgaon'
    },
    {
        value: 'delhi',
        label: 'Delhi'
    },
    {
        value: 'faridabad',
        label: 'Faridabad'
    },
    {
        value: 'ghaziabad',
        label: 'Ghaziabad'
    },
    {
        value: 'noida',
        label: 'Noida'
    },
    {
      value: 'jaipur',
      label: 'Jaipur'
  }
]

export const amenitiesData = [
    {
      label: "Testing",
      value: "testing"
    },
    {
      label: "Outdoor Games",
      value: "outdoor_games"
    },
    {
      label: "Presentation Area/Stage",
      value: "presentation_area_stage"
    },
    {
      label: "Kids Allowed",
      value: "kids_allowed"
    },
    {
      label: "Microbrewery",
      value: "microbrewery"
    },
    {
      label: "Private Dining Room(s)",
      value: "private_dining_rooms"
    },
    {
      label: "Play Area",
      value: "play_area"
    },
    {
      label: "Games",
      value: "games"
    },
    {
      label: "Outdoor Space",
      value: "outdoor_space"
    },
    {
      label: "Outside Decorator Allowed",
      value: "outside_decorator_allowed"
    },
    {
      label: "In-house Decorator Available",
      value: "in_house_decorator_available"
    },
    {
      label: "Mandap",
      value: "mandap"
    },
    {
      label: "Baraat Allowed",
      value: "baraat_allowed"
    },
    {
      label: "Hawan",
      value: "hawan"
    },
    {
      label: "Outside Drinks Allowed",
      value: "outside_drinks_allowed"
    },
    {
      label: "Wheelchair Accessibility",
      value: "wheelchair_accessibility"
    },
    {
      label: "Full Bar Available",
      value: "full_bar_available"
    },
    {
      label: "Lift",
      value: "lift"
    },
    {
      label: "Dedicated Dance Floor",
      value: "dedicated_dance_floor"
    },
    {
      label: "Live Screening",
      value: "live_screening"
    },
    {
      label: "Live Music",
      value: "live_music"
    },
    {
      label: "Outside Catering Allowed",
      value: "outside_catering_allowed"
    },
    {
      label: "In-house Catering Available",
      value: "in_house_catering_available"
    },
    {
      label: "Live Sports Screening",
      value: "live_sports_screening"
    },
    {
      label: "Smoking Area",
      value: "smoking_area"
    },
    {
      label: "Indoor Only",
      value: "indoor_only"
    },
    {
      label: "Outdoor Only",
      value: "outdoor_only"
    },
    {
      label: "Indoor & Outdoor",
      value: "indoor_and_outdoor"
    },
    {
      label: "Wifi/Internet",
      value: "wifi_internet"
    },
    {
      label: "Table and Chairs",
      value: "table_and_chairs"
    },
    {
      label: "Swimming Pool",
      value: "swimming_pool"
    },
    {
      label: "Stage",
      value: "stage"
    },
    {
      label: "Rooms Available",
      value: "rooms_available"
    },
    {
      label: "Roof Top",
      value: "roof_top"
    },
    {
      label: "Projector Screen",
      value: "projector_screen"
    },
    {
      label: "Power Backup",
      value: "power_backup"
    },
    {
      label: "Pool Table",
      value: "pool_table"
    },
    {
      label: "Parking",
      value: "parking"
    },
    {
      label: "Live Band",
      value: "live_band"
    },
    {
      label: "Hookah",
      value: "hookah"
    },
    {
      label: "DJ Available",
      value: "dj_available"
    },
    {
      label: "Catering",
      value: "catering"
    },
    {
      label: "Bowling Alley",
      value: "bowling_alley"
    },
    {
      label: "A/V Equipment",
      value: "av_equipment"
    },
    {
      label: "Air Conditioning",
      value: "air_conditioning"
    }
  ];
  
  export const withRouterParams = (Component) => {
    return function Wrapper(props) {
      const params = useParams();
      return <Component {...props} params={params} />;
    };
  };


export const VendorList = [
    {
        value: 'photographer',
        label: 'Photographer'
    },
    {
        value: 'mehandi-artist',
        label: 'Mehendi-Artist'
    },
    {
        value: 'makeup-artist',
        label: 'Makeup-Artist'
    },
    {
        value: 'decorator',
        label: 'Decorator'
    },
    {
        value: 'event-planner',
        label: 'Event-Planner'
    },
    {
        value: 'wedding-stylist',
        label: 'Wedding-Stylis'
    },
    {
        value: 'caterer',
        label: 'Caterer'
    },
    {
        value: 'choreographer',
        label: 'Choreographe'
    },
    {
        value: 'dj',
        label: 'Dj'
    },
    {
        value: 'anchor',
        label: 'Anchor'
    },
    {
        value: 'wedding-entertainer',
        label: 'Wedding-Entertainer'
    },
    {
        value: 'pandit',
        label: 'Pandit'
    },
    {
        value: 'car',
        label: 'Car'
    },
    {
        value: 'bartender',
        label: 'Bartender'
    },
    {
        value: 'event-equipment',
        label: 'Event-Equipment'
    },

]

export const visitStatusOption = [
    {
        value:"Visit Scheduled",
        label: "Visit Scheduled"
    },
    {
        value:"Visit Done",
        label: "Visit Done"
    }

]

export const SUBSCRIPTION_EXPIRED = "Your Subscription Plan is Expired"
export const SUBSCRIPTION_EXPIRED_RIBBON = "Hi, Your subscription has expired! Kindly connect with VenueMonk Business Team to extend the subscription! Please contact us at"
